var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreadcrumbSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68306 6.00768C7.92714 5.77523 8.32286 5.77523 8.56694 6.00768L12.3169 9.57911C12.561 9.81157 12.561 10.1885 12.3169 10.4209L8.56694 13.9923C8.32286 14.2248 7.92714 14.2248 7.68306 13.9923C7.43898 13.7599 7.43898 13.383 7.68306 13.1505L10.9911 10L7.68306 6.84948C7.43898 6.61702 7.43898 6.24014 7.68306 6.00768Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbSeparator);
export default __webpack_public_path__ + "static/media/BreadcrumbSeparator.a9d7a06af3b966ae88a2839c603ce7af.svg";
export { ForwardRef as ReactComponent };